import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2a851ce3&scoped=true&lang=pug&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=2a851ce3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a851ce3",
  null
  
)

export default component.exports